import { storageAuthName, storageTokenName } from 'constants/storage'

// Для работы хука useLocalStorage
const dispatchEventStorage = () => {
  const eventStorage = new Event('local-storage')
  window.dispatchEvent(eventStorage)
}

const storage = {
  setItem: <T>(name: string, data: T): void => {
    const stringifiedData = JSON.stringify(data)
    window.localStorage.setItem(name, stringifiedData)
  },
  getItem: <T>(name: string): T | null => {
    const data = window.localStorage.getItem(name)
    if (!data) {
      return null
    }
    return JSON.parse(data) as T
  },
  getToken: (): string => window.localStorage.getItem(storageTokenName) as string,
  setToken: (token: string): void => {
    window.localStorage.setItem(storageTokenName, token)
    window.localStorage.setItem(storageAuthName, JSON.stringify({ value: !!token }))
  },
  clearToken: (): void => {
    window.localStorage.removeItem(storageTokenName)
    window.localStorage.removeItem(storageAuthName)
    dispatchEventStorage()
  },
}

export default storage
